import './Nav.css'
import { GoabAppHeaderMenu } from "@abgov/react-components";
import { useAuth } from 'react-oidc-context';
import { parseToken } from '../apis/tokenUtil';

interface NavProps {
  // forwarded so the root element carries the slot attribute when cloned by GoabAppHeader's utilities/navigation props
  slot?: string;
}

export const Nav = ({ slot }: NavProps) => {
  const auth = useAuth();
  const logout = () => {
    if (!auth.isLoading && auth.isAuthenticated) {
      auth.signoutRedirect({ id_token_hint: auth.user?.id_token }).then();
    }
  };
  return (
    <div slot={slot} style={{display: 'inline-block'}}>
      { auth.isAuthenticated &&
        <>
          <GoabAppHeaderMenu heading={parseToken(auth.user?.id_token as string)?.email} leadingIcon="person-circle">
          {
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a onClick={logout}>Log out</a> 
          }
          </GoabAppHeaderMenu>
        </>
      }
    </div>

  )
};

